import React from "react";
import PortConfigurationOperation from "./nassau-react/PortConfiguratorOperation";
import WhenStep from "./nassau-react/navigation/WhenStep";
import WhenNotStep from "./nassau-react/navigation/WhenNotStep";
import StepNavigation from "./nassau-react/navigation/StepNavigation";
import CurrentStep from "./nassau-react/navigation/CurrentStep";
import PortStep from "./nassau-react/steps/PortStep";
import ExtrasStep from "./nassau-react/steps/ExtrasStep";
import RailsStep from "./nassau-react/steps/RailsStep";
import DeliveryStep from "./nassau-react/steps/DeliveryStep";
import Help from "./nassau-react/misc/Help";
import Logo from "./nassau-react/misc/Logo";
import FinalStepMarkup from "./nassau-react/steps/FinalStepMarkup";
import PortImage from "./nassau-react/port-image/PortImage";
import StepFooter from "./nassau-react/misc/StepFooter";
import ImageLayer from "./nassau-react/port-image/ImageLayer";
import ImageInfo from "./nassau-react/misc/ImageInfo";

export default function PortConfigurator({initialPorts,available_payment_gateways}) {
    return (
        <div id={'port-configurator'}>
            <PortConfigurationOperation initialPorts={initialPorts} available_payment_gateways={available_payment_gateways}>
                <div className={"port-steps"}>
                    <WhenNotStep step={4}>
                        <section className={"step port-step"}>
                            <aside className={"step-product-wrap"}>
                                <div className={"step-product-section"}>
                                    <header id={"port-configurator-header"} className={"configurator-header"}>
                                        <div className={"configurator-header__content"}>
                                            <Logo/>
                                            <StepNavigation/>
                                            <CurrentStep text={'Step '}/>
                                            <Help/>
                                        </div>
                                    </header>
                                    <main className={"port-image-wrap"}>
                                        <WhenNotStep step={2}>
                                            <PortImage />
                                        </WhenNotStep>
                                        <WhenStep step={2}>
                                            <ImageLayer name={'rails_type'} className={'port-image__base'} />
                                        </WhenStep>
                                        <ImageInfo />
                                    </main>
                                    <StepFooter/>
                                </div>
                            </aside>
                            <aside className={"step-form-wrap"}>
                                <div className={"step-form-section"}>
                                    <div className="form">
                                        <WhenStep step={0}>
                                            <PortStep/>
                                        </WhenStep>
                                        <WhenStep step={1}>
                                            <ExtrasStep/>
                                        </WhenStep>
                                        <WhenStep step={2}>
                                            <RailsStep/>
                                        </WhenStep>
                                        <WhenStep step={3}>
                                            <DeliveryStep/>
                                        </WhenStep>
                                    </div>
                                </div>
                            </aside>
                        </section>
                    </WhenNotStep>
                    <WhenStep step={4}>
                        <FinalStepMarkup />
                    </WhenStep>
                </div>
            </PortConfigurationOperation>
        </div>
    );
}